module.exports = __webpack_public_path__ + "static/media/4.fa673ff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/4.jpg
// module id = 363
// module chunks = 0